module.exports = __webpack_public_path__ + "img/mystery-ticket-bg.ace7c8fb.png";